// import "./styles.css";
// https://codesandbox.io/p/sandbox/react-quill-with-react-typescript-fgs2vb?file=%2Fsrc%2FApp.tsx%3A15%2C12
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from 'quill-image-resize-module-react';
import Quill from 'quill';  // Import Quill
import { Mention } from 'quill-mention';
import { Const } from "const";
import { Utils } from "helpers/utils";
import AppSimpleBar from "./AppSimpleBar";
import Loader from "./Loader";
import { APIClient } from "api/apiCore";
import { debounce, last, set } from "lodash";
import { useRedux } from "hooks";
import * as url from "../api/urls";
import { sp_WpFindTag, QuillFileUpload, ATypes, QuillTagData, MemberRole, WpSliceData, WpEmpFilterType, WpPostInfo, WpStatus } from "../redux/workplace/wpTypes";
import { setActivePostId2, appendPostConver, loadPostInfo, setActiveMemberrole, setCreateSubTask, setPostInfoOnSignalR } from "../redux/workplace/wpActions";
import { changeSelectedChat } from "../redux/actions";
import { UAParser as UA } from 'ua-parser-js';
import LoadingIconWithText from "./LoadingIconWithText";
import classnames from "classnames";
import { ta } from "date-fns/locale";
import { createSelector } from "reselect";
import { WorkPlaceCatFilter, WorkPlaceTagFilter } from "../redux/workplace/wpTypes";
import FloatingToolbox from "./FloatingToolbox";
import WpTagToolbox from "pages/Dashboard/Common/WpTagToolbox";
import { TABS, WpModes } from "../constants";
import { TaskFormFieldData } from "../types";
import TaskFormField from "pages/Dashboard/Workplace/TaskFormField";
const Link = ReactQuill.Quill.import('formats/link') as any;



interface LinkValue {
  href: string;
  class?: string;
  atype?: string;
  aval?: string;
  id?: string;
}

// 20250508 handle clipboard reserve custom tag
class CustomLink extends Link {
  // static blotName = 'customlink'; // use a different blot name
  // static tagName = 'A';

  // 20260821 A bare domain typed into the link tooltip (e.g. "www.google.com") has no scheme,
  // so the browser treats it as a path relative to the current page instead of an absolute URL
  // (Quill's own sanitize() only validates the protocol via an <a> the browser already resolved
  // against location - it never rewrites the href). Default missing-scheme values to https:// so
  // typed links behave the same as if the user had typed the full https://... themselves; leave
  // "#" (used by our tag links), other in-app relative paths, and anything with a real scheme
  // (http:, mailto:, tel:, ...) untouched.
  static normalizeHref(href: string): string {
    const trimmed = href.trim();
    if (trimmed === '' || trimmed === '#') return trimmed || '#';
    if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed) || trimmed.startsWith('#') || trimmed.startsWith('/')) {
      return trimmed;
    }
    return `https://${trimmed}`;
  }

  static create(value: string | LinkValue): HTMLElement {
    let href = '#';

    if (typeof value === 'string') {
      href = value;
    } else if (value && typeof value === 'object' && value.href) {
      href = value.href;
    }

    href = CustomLink.normalizeHref(href);

    const node = super.create(href);

    if (value && typeof value === 'object') {
      if (value.class) node.setAttribute('class', value.class);
      if (value.atype) node.setAttribute('atype', value.atype);
      if (value.aval) node.setAttribute('aval', value.aval);
      if (value.id) node.setAttribute('id', value.id);
    }

    return node;
  }

  static formats(domNode: HTMLElement): LinkValue {
    const base = super.formats(domNode) || {};
    return {
      ...base,
      class: domNode.getAttribute('class') || undefined,
      atype: domNode.getAttribute('atype') || undefined,
      aval: domNode.getAttribute('aval') || undefined,
      id: domNode.getAttribute('id') || undefined,
    };
  }

  format(name: string, value: any): void {
    if (['class', 'atype', 'aval', 'id'].includes(name)) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      const normalizedValue = name === 'link' && typeof value === 'string' ? CustomLink.normalizeHref(value) : value;
      super.format(name, normalizedValue);
      // 20260821 Quill reuses the same DOM node (instead of creating a fresh one) when the
      // 'link' format is re-applied - via the toolbar's default link button/tooltip - to a
      // range that's already entirely one link blot (e.g. re-selecting an old @tag/file/image
      // link and giving it a new URL). That path only ever passes a plain string/false, so
      // super.format() above only touches href/target - without this, the old atype/class/aval
      // would silently survive onto what now looks like an ordinary hyperlink.
      if (name === 'link' && (value === null || typeof value !== 'object')) {
        this.domNode.removeAttribute('atype');
        this.domNode.removeAttribute('aval');
        this.domNode.removeAttribute('class');
      }
    }
  }
}

ReactQuill.Quill.register(CustomLink, true);
ReactQuill.Quill.register('modules/imageResize', ImageResize);
ReactQuill.Quill.register('modules/mention', Mention);

const escapeHtml = (s: string): string =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

// 20260821 Flags <a> tags whose atype/href look inconsistent with their visible text - the
// pattern reported when a plain hyperlink silently inherits atype/class from an old @tag/file/
// image link it replaced (see CustomLink.format). Heuristic only, so it's used to warn-and-let-
// the-user-decide rather than to hard-block posting.
const findSuspiciousLinks = (root: HTMLElement): string[] => {
  const issues: string[] = [];
  root.querySelectorAll('a').forEach((a) => {
    const atype = a.getAttribute('atype');
    const text = (a.textContent || '').trim();
    const href = a.getAttribute('href') || '';
    const label = escapeHtml(text || '(ไม่มีข้อความ)');

    if (atype === ATypes.tag) {
      if (!text.startsWith('@')) {
        issues.push(`"${label}" ถูกทำเครื่องหมายเป็นแท็ก (@) แต่ข้อความไม่ได้ขึ้นต้นด้วย @`);
      }
    } else if (atype === ATypes.file || atype === ATypes.image) {
      // Real uploads always land on <a class="a-file"> (file) or <img> (image, never <a>) with a
      // real href - anything else on an <a> here is very likely a stale atype, not a real upload.
      if (atype === ATypes.image || !a.classList.contains('a-file') || !href || href === '#') {
        issues.push(`"${label}" ถูกทำเครื่องหมายเป็นไฟล์แนบ/รูปภาพ (atype="${atype}") ทั้งที่ดูเหมือนเป็นลิงก์ปกติ`);
      }
    } else if (!href || href === '#') {
      issues.push(`"${label}" เป็นลิงก์ที่ยังไม่ได้ระบุ URL`);
    }
  });
  return issues;
};

interface WorkplaceQuillProps {
  editorMinHeight: number;
  editorMaxHeight: number;
  isLargeStage: boolean;
  onLargeStageClick: () => void;
  allTags?: WorkPlaceCatFilter[] | null;
  wpMode: WpModes;
  instantMode: boolean,
  // 20261020 true while the post's member check is still running - typing is allowed, sending is not
  sendLocked?: boolean,
  // onSave: (text: string, html: string, blobUploads: QuillFileUpload[]) => void;
  // onSaving: boolean;
}

export default function WorkplaceQuill({ wpMode, instantMode, editorMinHeight: editorMinHeightParm, editorMaxHeight: editorMaxHeightParm, isLargeStage, allTags, onLargeStageClick, sendLocked = false/*, onSave, onSaving*/ }: WorkplaceQuillProps) {
  // ref so the Enter-to-send keyboard handler (registered once) sees the current value
  const sendLockedRef = useRef<boolean>(sendLocked);
  sendLockedRef.current = sendLocked;
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (state: any) => state.Profile2,
    (wp: WpSliceData, p2) => ({
      activePostId: wp.activePostInfo.postId, //wpMode == WpModes.Workplace ? wp.activePostInfo.postId : wp.activeTaskInfo.postId,
      createSubTaskFromTaskId: wp.createSubTaskFromTaskId,
      activeMemberRole: wpMode == WpModes.Workplace ? wp.activeMemberRole : wp.activeMemberRoleTk,
      tagFilterSelected: wpMode == WpModes.Workplace ? wp.tagFilterSelected : wp.tagFilterSelectedTk,
      isEmbChatOnly: wp.isEmbChatOnly,
      curUserId: p2.userId,
      tagMasterCats: wp.tagMasterCats,
    })
  );
  // Inside your component
  const { activePostId, createSubTaskFromTaskId, activeMemberRole, tagFilterSelected, isEmbChatOnly, curUserId, tagMasterCats } = useAppSelector(storeData);
  const isCreateSubTaskMode = createSubTaskFromTaskId ? true : false;

  const fnGetTopperHeight = () => {
    const isNewTask = wpMode == WpModes.Task && (!activePostId || isCreateSubTaskMode);
    // console.log('isNewTask = ' + isNewTask);
    if (!isNewTask) return 0;
    const bodyCss = localStorage.getItem("bodyFontClass");
    // console.log('bodyCss:' + bodyCss);
    switch (bodyCss) {
      case 'body-font-default': return 260;
      case 'body-font-step10': return 280;
      case 'body-font-step11': return 300;
      case 'body-font-step12': return 320;
      case 'body-font-step13': return 340;
      case 'body-font-step14': return 360;
    }
    return 260; // default
  }

  //const INPUT_TOPPER_HEIGHT = (wpMode == WpModes.Task && !activePostId) ? 260 : 0; // แสดง form ด้านบนเมื่อเป็น Task และ New Mode
  const INPUT_TOPPER_HEIGHT = fnGetTopperHeight(); //(wpMode == WpModes.Task && !activePostId) ? 360 : 0; // แสดง form ด้านบนเมื่อเป็น Task และ New Mode
  // console.log('INPUT_TOPPER_HEIGHT:', INPUT_TOPPER_HEIGHT);
  const editorMinHeight = editorMinHeightParm - INPUT_TOPPER_HEIGHT;
  const editorMaxHeight = editorMaxHeightParm - INPUT_TOPPER_HEIGHT;

  const emptyTaskData: TaskFormFieldData = {
    taskName: "",
    projectId: null,
    assignerId: curUserId,
    respondId: null,
    requestBy: null,
    planFinishedDate: null,
    createSubTaskFromTaskId: createSubTaskFromTaskId,
  }

  const [showEmojiToolPlate, setShowEmojiToolPlate] = useState<boolean>(false);
  // const [taskData, setTaskData] = useState<TaskFormFieldData>({
  //   taskName: "",
  //   projectId: null,
  //   assignerId: curUserId,
  //   respondId: null,
  //   requestBy: null,
  //   planFinishedDate: null,
  //   createSubTaskFromTaskId: createSubTaskFromTaskId,
  // });
  const [taskData, setTaskData] = useState<TaskFormFieldData>(emptyTaskData);
  // useEffect(() => {
  //   console.log('taskData:', taskData);
  // }, [taskData]);
  // const onTaskFormChanged = (key: "taskName" | "projectId" | "assignerId" | "respondId" | "planFinishedDate", value: any) => {
  //   console.log(`onTaskFormChanged key = ${key}, value = ${value}`);
  // }

  const onTaskFormChanged = useCallback(
    (key: keyof TaskFormFieldData, value: string) => {
      // console.log(`onTaskFormChanged key = ${key}, value = ${value}`);
      // setTaskData(prev => ({ ...prev, [key]: value }));
      setTaskData(prev => {
        const updated = { ...prev, [key]: value };
        Utils.WpDraft_SaveTk(updated);

        return updated;
      });

    }, []
  );


  useEffect(() => {
    setTaskData(prev => ({ ...prev, createSubTaskFromTaskId: createSubTaskFromTaskId }));
  }, [createSubTaskFromTaskId]);

  // useEffect(() => {
  //   console.log('taskData:', taskData);
  // }, [taskData])

  const emojis = [
    { name: 'OK', icon: '🆗' },
    { name: 'Smile', icon: '😊' },
    { name: 'Cry', icon: '😢' },
    { name: 'Crying Smile', icon: '😂' },

    { name: 'Good', icon: '👍' },
    { name: 'Thank you', icon: '🙏' },
    { name: 'Strong', icon: '💪' },
    { name: 'Crab', icon: '👏' },

    { name: 'Done', icon: '✅' },
    { name: 'No', icon: '❌' },
    { name: 'Smile Glasses', icon: '😎' },
    { name: 'Ok Hand', icon: '👌' },

    // { name: 'Plus 1', icon: '➕' },
    // { name: 'Minus 1', icon: '➖' },

    { name: '100%', icon: '💯' },
    { name: 'Love', icon: '❤️' },
    // { name: 'Negative', icon: '🆖' }, //{ name: 'Wait', icon: '⌛' },
    { name: 'Delivery', icon: '🚚' },
    { name: 'Soon', icon: '🔜' },

    // { name: 'Plus', icon: '➕' },
    // { name: 'GoodLove', icon: '🫰🏻' },
    // { name: 'Minus 1', icon: '➖' },
    // { name: 'OMG', icon: '😱' },
  ];

  useEffect(() => {

    // custom icon
    const icons: [string, string, string][] = [
      // ['ql-bold', 'fas fa-bold'],
      // ['ql-italic','fas fa-italic'],
      // ['ql-underline', 'fas fa-underline'],
      // ['ql-strike', 'fas fa-strikethrough'],
      // ['ql-color', 'fas fa-strikethrough'],
      ['ql-formula', 'fas fa-paperclip', 'แนบไฟล์'],
      ['ql-direction', 'far fa-smile', 'อีโมจิ'],
      ['ql-strike', 'fas fa-at', 'เปิดหน้า tag'],
      ['ql-customtag', 'fas fa-at', 'เปิดหน้า tag'],
      ['ql-clean', 'fas fa-eraser', 'ล้างรูปแบบข้อความ']
      // ['xxx', 'xxxx'],
      // ['xxx', 'xxxx'],
      // ['xxx', 'xxxx'],
      // ['xxx', 'xxxx'],
      // ['xxx', 'xxxx'],
    ];
    icons.forEach((key) => {
      const btn = document.querySelector('.' + key[0]) as HTMLButtonElement;
      if (btn) {
        btn.innerHTML = '<i class="' + key[1] + ' ql-fa"></i>'; // Bootstrap icon for bold
        btn.title = key[2];
        if (btn.classList.contains("ql-direction")) {
          btn.onclick = (e) => {
            e.preventDefault();
            setShowEmojiToolPlate(prev => !prev);
            // console.log('click direction');
          }
        } else if (btn.classList.contains("ql-customtag")) {
          btn.onmousedown/*onclick*/ = (e) => {
            e.preventDefault();
            setWpTagToolboxOpen(prev => !prev);
          }
        }
      }
    })

    // const boldButton = document.querySelector('.ql-bold') as HTMLButtonElement;
    // if (boldButton) {
    //    boldButton.innerHTML = '<i class="fas fa-bold"></i>'; // Bootstrap icon for bold
    //  }    

    // This will make Quill globally accessible on the window object
    window.Quill = Quill;
  }, []);

  const myColors = [
    "#000000", "#FFFFFF", "#FF0000", "#008000", "#0000FF", "#FFFF00", "#FFA500",
    "#800080", "#A52A2A", "#808080", "#C0C0C0", "#800000", "#FF6347", "#FFD700",
    "#ADFF2F", "#4B0082", "#F0E68C", "#90EE90", "#D3D3D3", "#FF1493", "#20B2AA",
    "#A9A9A9", "#8B0000", "#32CD32", "#00008B", "#FF4500", "#2E8B57", "#8A2BE2",
  ];

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "background",
    "align"
  ];






  const quillRef = useRef<ReactQuill | null>(null);
  const [mentions, setMentions] = useState<sp_WpFindTag[]>([]);
  const [mentionLength, setMentionLength] = useState<number>(0);
  const mentionLengthRef = useRef<number>(0);
  const [mentionIndex, setMentionIndex] = useState<number>(-1);
  const [isFindTag, setIsFindTag] = useState<boolean>(false);
  const [showMentionDropdown, setShowMentionDropdown] = useState<boolean>(false);
  const showMentionDropdownRef = useRef<boolean>(false);
  const [cursorPosition, setCursorPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
  const [cursorBound, setCursorBound] = useState<any>(null);
  const [lastTagRange, setLastTagRange] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [onSaving, setOnSaving] = useState<boolean>(false);

  const mentionIndexRef = useRef<number>(-1);
  const mentionsRef = useRef<sp_WpFindTag[]>([]);
  const lastTagRangeRef = useRef<any>(null);

  const [code, setCode] = useState("");

  useEffect(() => { showMentionDropdownRef.current = showMentionDropdown; }, [showMentionDropdown]);
  useEffect(() => { mentionLengthRef.current = mentionLength; }, [mentionLength]);
  useEffect(() => { mentionIndexRef.current = mentionIndex; }, [mentionIndex]);
  useEffect(() => { mentionsRef.current = mentions; }, [mentions]);
  useEffect(() => { lastTagRangeRef.current = lastTagRange; }, [lastTagRange]);

  const debounceOnChange = useMemo( /* useMemo make debounce not call every render*/
    () =>
      debounce((postId: string, content: string) => {
        Utils.WpDraft_Save(wpMode, postId, content, dispatch);
        // console.log('Debounce Utils.WpDraft_Save ' + postId );
      }, 700),
    [dispatch] // include only dependencies that should recreate debounce
  );
  // 20261020 write the pending draft when the editor unmounts (e.g. member check says "not member" and the
  // panel swaps to Join) so the text typed meanwhile comes back after joining
  useEffect(() => () => { debounceOnChange.flush(); }, [debounceOnChange]);

  const handleProcedureContentChange = (content: any) => {
    setCode(content);

    if (quillRef && quillRef.current) {
      const containsImg = content.toLowerCase().indexOf('<img') >= 0;
      const plainText = quillRef.current.getEditor().getText().trim();
      const empty = !containsImg && plainText == "";

      const setContent = empty ? plainText : content;
      // const isDraft = setContent != "";
      debounceOnChange(activePostId ?? "", setContent);
      // Utils.WpDraft_Save(activePostId ?? "", setContent, dispatch);
    }
  };

  const fnLoadDraft = async (postId: string) => {
    try {
      // 20260126 task
      if (wpMode == WpModes.Task) {
        if (!createSubTaskFromTaskId) {
          const data = await Utils.WpDraft_LoadTk();
          if (data != null) {
            data.assignerId = curUserId;
            setTaskData(data);
          }
        }
      }

      const draft = Utils.WpDraft_Load(wpMode, postId);
      if (draft && draft != "") { // load draft
        const quill = quillRef?.current?.getEditor()
        if (quill) {
          const htmlContent = draft;
          //           const htmlContent = `<p>Hello test</p><p><strong><u>Format </u>Text</strong></p><p>Clipboard Picture</p><p><img src="blob:http://localhost:3000/363bd31e-effe-4285-b829-5f82f916dd74" id="0a897681-7261-4037-93f6-ca8f31d7dd17" class="ql-imginline" atype="image" fname="">\</p><p>
          // <a href="blob:http://localhost:3000/19db6124-44d5-4f2e-8fb9-d07ca85d1e7b" rel="noopener noreferrer" target="_blank" id="3c44a036-44ad-4f8e-baa8-9dd01c1b2532" atype="file" class="a-file">Link to google</a></p><p>Picture upload</p><p>
          // <img src="blob:http://localhost:3000/078c5d69-0e5b-4392-9158-3cacba2b2dd0" id="947858c5-31a6-4400-a288-0e296976acd0" class="ql-imginline" atype="image" fname="รดกวาด 1.webp"></p><p>File upload</p><p>
          // <a href="blob:http://localhost:3000/19db6124-44d5-4f2e-8fb9-d07ca85d1e7b" rel="noopener noreferrer" target="_blank" id="049de794-2379-431e-886d-09de30a4860f" atype="file" class="a-file">⏹MS680-EndUser_thumbnail.jpg</a> </p>`;
          // console.log('htmlContent:', htmlContent);
          // Parse HTML string to DOM
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlContent, 'text/html');

          // Get all <a> elements
          const atypeElements = doc.querySelectorAll('a,img');

          // console.log('parse2:', doc.documentElement.outerHTML);
          const htmlContent2 = doc.documentElement.outerHTML;

          // Store id and href in an array for later
          const linkData = Array.from(atypeElements).filter(e => e.tagName === 'A' || e.tagName === 'IMG').map(link => ({
            id: link.id,
            tagName: link.tagName,
            href: link.getAttribute('href'),
            src: link.getAttribute('src'),
            fname: link.getAttribute('fname'),
            class: link.getAttribute('class'),
            atype: link.getAttribute('atype'),
            aval: link.getAttribute('aval'),
          }));

          // reformat image because quill will change it
          atypeElements.forEach(e => {
            if (e.tagName === 'IMG') {
              e.setAttribute('src', '/' + e.id);
            }
          });
          // console.log('linkData:', linkData);

          setTimeout(() => {
            quill.clipboard.dangerouslyPasteHTML(htmlContent2);
            const htmlPared = quill.root.innerHTML;
            // console.log('htmlPared1:', htmlPared);
            const atypeElements = quill.root.querySelectorAll('a,img');
            if (atypeElements.length != linkData.length) throw new Error("There are some error that draft text and quill parsing get not same element");

            for (let i = 0; i < atypeElements.length; ++i) { // have to use loop like this bacause quill remove all attribute of tag <img> then have to do sy index sequence
              const quillElement = atypeElements[i];
              const data = linkData[i];
              if (quillElement.tagName === 'A') {
                if (data.atype == "tag") {
                  quillElement.setAttribute('href', "#");
                  quillElement.setAttribute('id', data.id);
                  quillElement.setAttribute('target', '_blank');
                  quillElement.setAttribute('rel', 'noopener noreferrer');
                  quillElement.setAttribute('atype', 'tag');
                  quillElement.setAttribute('class', 'a-tag');
                  quillElement.setAttribute('aval', data.aval ?? "");
                } else if (data.atype == "file") {
                  quillElement.setAttribute('href', data.href ?? "#");
                  quillElement.setAttribute('id', data.id);
                  quillElement.setAttribute('target', '_blank');
                  quillElement.setAttribute('rel', 'noopener noreferrer');
                  quillElement.setAttribute('atype', 'file');
                  quillElement.setAttribute('class', 'a-file');
                } else {
                  console.error(`Not support for atype '${data.atype}'`);
                }
              } else if (quillElement.tagName === 'IMG') {
                quillElement.setAttribute('src', data.src ?? "");
                quillElement.setAttribute('id', data.id);
                quillElement.setAttribute('class', 'ql-imginline');
                quillElement.setAttribute('atype', 'image');
                quillElement.setAttribute('fname', data.fname ?? "");
              } else {
                console.error(`Not support tag '${quillElement.tagName}' when load draft to workplace editor`);
              }
            }
            computeTag();
            // const htmlPared2 = quill.root.innerHTML;
            // console.log('htmlPared2:', htmlPared2);

            // atypeElements.forEach(el => {
            //   if (el.id) {
            //     console.log('process for id = ' + el.id);
            //     if (el.tagName === 'A') {
            //       const found = linkData.find(x => x.id == el.id);
            //       if (found) {
            //         el.setAttribute('href', found.href ?? "#");
            //         console.log(`set href = '${found.href}' to '${found.id}'`);
            //       } else {
            //         console.error(`Not found A id ${el.id}`);
            //       }
            //     } else if (el.tagName === 'IMG') {
            //       const found = linkData.find(x => x.src == '/' + el.id);
            //       if (found) {
            //         el.setAttribute('id', el.id);
            //         el.setAttribute('src', found.src ?? "");
            //         console.log(`set src = '${found.src}' to '${found.id}'`);
            //       } else {
            //         console.error(`Not found img src = /${el.id}`)
            //       }
            //     }
            //   }
            // });
            // const htmlPared2 = quill.root.innerHTML;
            // console.log('htmlPared2:', htmlPared2);
          }, 200);
        }
        return true;
      } else {
        return false;
      }


    } catch (e) {
      Utils.HandleException(e, true);
      return false;
    }
  }

  useEffect(() => {
    const run = async () => {
      setCode("");
      //const editor = quillRef.current?.getEditor(); // Get Quill instance
      // if (editor) {
      //   // Set initial content with bold and underlined text
      //   editor.setContents([
      //     { insert: "" },
      //     // { insert: "XXX", attributes: { bold: true, underline: true } },
      //   ]);
      // }
      const haveDraft = await fnLoadDraft(activePostId ?? "");
      if (!haveDraft && activePostId == "") { //new post
        const quill = quillRef?.current?.getEditor()
        if (quill) {
          quill.setText(""); // clear existing data
          let index = 0;
          tagFilterSelected.forEach((tag) => {
            const tagName = `@${tag.name}`;

            // Insert the text
            quill.insertText(index, tagName, "link", "#");

            // reformat
            const links = quill.root.querySelectorAll('a');// as HTMLImageElement;
            links.forEach((lnk) => {
              if (!lnk.id) {
                lnk.id = Utils.GetUniqueId();
                lnk.href = "#";
                lnk.className = "a-tag";
                lnk.setAttribute('atype', ATypes.tag);
                lnk.setAttribute('aval', tag.tagId.toString());
              }
            });

            // Move cursor index forward by tag length
            index += tagName.length;

            // Insert a space after each tag
            quill.insertText(index /*+ tagName.length*/, ' ', 'link', false);
            index += 1;
          });
          setTimeout(() => {
            if (tagFilterSelected.length > 0) {
              quill.insertText(index, '\n'); // insert newline before the final newline
              computeTag();
            }
            const length = quill.getLength(); // gets total content length including trailing \n
            quill.setSelection(length - 1, 0); // set cursor at end
            quill.focus(); // optional if you want to ensure editor is focused
          }, 200);
        }
      }
    };
    run();
  }, [activePostId]);

  useEffect(() => {
    // console.log('cursorPosition:', cursorPosition);
  }, [cursorPosition]);


  const lastFindTagTermRef = useRef<string>("");
  const debounceFindTag = useCallback(
    debounce((keyword: string) => {
      setIsFindTag(true);
      //console.log("debounceFindTag:"+keyword);
      // dispatch(findMemberToGroup(groupId, filter, filterUserType));
      try {
        const api = new APIClient
        // 20261021 space = AND: "@a b" -> "a,b" (backend splits on ',' and ANDs each part, ilike)
        const apiKeyword = keyword.trim().split(/\s+/).filter(x => x).join(',');
        api.fnPostForm(url.WP_FIND_TAG, { keyword: apiKeyword })
          .then((rs) => {
            setMentionLength(rs.length);
            setMentionIndex(rs.length > 0 ? 0 : -1);
            setMentions(rs);
            setIsFindTag(false);
            // multi-word term with no match -> treat the words as normal text, close the dropdown
            if (rs.length === 0 && /\s/.test(keyword.trim()) && lastFindTagTermRef.current === keyword) {
              setShowMentionDropdown(false);
            }
          })
          .catch((err) => {
            setIsFindTag(false);
            Utils.HandleException(err);
          });
      } catch (e) {
        setIsFindTag(false);
        Utils.HandleException(e);
      }

    }, 800),
    [] // Dependencies are empty so it's only created once
  );

  const showMentionDropdownAndSearch = async (searchTerm: string) => {
    setSearchTerm(searchTerm);
    lastFindTagTermRef.current = searchTerm;
    //if (searchTerm != "" || mentions.length <= 0) {
    debounceFindTag(searchTerm);
    //}
    setShowMentionDropdown(true);

  };

  const isSavingRef = useRef(false);

  useEffect(() => {
    const quill = quillRef.current?.getEditor();

    if (quill) {
      // Add the Image Resize module to the Quill instance
      quill.getModule('imageResize');

      const fnProcessImageAfterAdd = (blobUrl: string, fileName: string) => {
        const images = quill.root.querySelectorAll('img');// as HTMLImageElement;
        // console.log('lastImage:', images);
        images.forEach((img) => {
          if (!img.id) {
            // if (!img.getAttribute('atype')) {
            img.id = Utils.GetUniqueId();
            img.src = blobUrl;
            // img.style.maxHeight = Const.MAX_INLINE_WORKPLACE_IMG_HEIGHT;
            // img.style.maxWidth = Const.MAX_INLINE_WORKPLACE_IMG_WIDTH;
            img.classList.add("ql-imginline");
            img.setAttribute('atype', ATypes.image);
            img.setAttribute('fname', fileName ?? "");
          }
        });
      }
      let storedRange: any = null;

      const handleClick = (event: any) => {
        setShowMentionDropdown(false);
        const target = event.target as HTMLElement;

        // Check if the clicked element is a link
        if (target.tagName === "A") {
          const href = target.getAttribute("href");

          // Check if this link should be editable
          if (href?.startsWith("#")) {
            event.preventDefault(); // Prevent Quill's URL prompt
            event.stopPropagation(); // Stop event bubbling to Quill
            const quillTooltip = document.querySelector(".ql-tooltip") as HTMLElement;
            if (quillTooltip) {
              quillTooltip.classList.add("ql-hidden");
            }
          }
        }
      }

      const handleKeyDown = (event: any) => {
        if (showMentionDropdownRef.current && (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === "Enter" || event.key === "Escape")) {
          if (event.key === "ArrowDown" || event.key === "ArrowRight") {
            // console.log('move selecction down:', mentionLengthRef.current);
            setMentionIndex(prev => (prev + 1) >= mentionLengthRef.current ? 0 : (prev + 1));
            // move selection down
          } else if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
            // move selection up
            // console.log('move selecction up');
            setMentionIndex(prev => (prev - 1) < 0 ? (mentionLengthRef.current - 1) : (prev - 1));
          } else if (event.key === "Escape") {
            // hide mention
            setShowMentionDropdown(false);
          } else if (event.key === "Enter") {
            // confirm selection
            // console.log('select mention ' + mentionIndex);
            handleMentionSelectByIndex();
          }
          event.preventDefault();
          return;
        }
        const range = quill.getSelection();
        storedRange = range;
        if (event.key === "Enter" && !event.shiftKey) {
          // const range = quill.getSelection(); // 20250224 move up to store selection every time on keydown 
          // storedRange = range;
          // console.log('storedRange:', storedRange);

          const parser = new UA();
          const deviceType = parser.getDevice().type;
          const isPc = !deviceType;
          //if (!isSavingRef.current && isPc) { /* enter = send if PC */
          if (!isSavingRef.current && isPc && isLargeStage == false) { /* enter = send if PC */
            // console.log('enter press, then send');
            event.preventDefault();
            // if (isLargeStage == false) { // 20250814 move isLargeState to above condition
            isSavingRef.current = true;
            onSaveIn();
            setTimeout(() => { isSavingRef.current = false; }, 500);

            // }
          }
        }
      }

      const handlePaste = (event: ClipboardEvent) => {
        const range = storedRange;
        //quill.focus();
        //const range = quill.getSelection();
        // if (!range){
        //   console.log('no range');
        //   return;
        // }

        const items = (event.clipboardData || (event as any).originalEvent.clipboardData).items;
        for (const item of items) {
          if (item.type.indexOf("image") === 0) {
            // console.log('paste image');
            event.preventDefault();
            if (range) {
              const file = item.getAsFile();
              if (file) {
                const blobUrl = URL.createObjectURL(file);
                // console.log('blobUrl = ' + blobUrl);
                quill.insertEmbed(range.index, 'image', blobUrl);
                // Delay cursor repositioning to ensure the editor has updated
                setTimeout(() => {
                  quill.setSelection(range.index + 1, 0);
                }, 10);
                fnProcessImageAfterAdd(blobUrl, "");

              }
            }

          }
        }
      };

      // Overriding the image insertion handler to set default size
      const imageHandlerSelect = (event: Event) => {
        const input = event.target as HTMLInputElement;
        const range = quill.getSelection();
        if (!range) return;
        if (input.files && input.files.length > 0) {
          let insertIndex = range.index;
          for (var ifile = 0; ifile < input.files?.length; ++ifile) {
            const file = input.files[ifile];
            if (file) {
              // blob
              const blobUrl = URL.createObjectURL(file);
              // console.log('blobUrl:', blobUrl);

              quill.insertEmbed(insertIndex, 'image', blobUrl); //imageNode.src);
              insertIndex++;

              fnProcessImageAfterAdd(blobUrl, file.name);

              if (ifile >= input.files?.length - 1) { // last
                quill.insertText(insertIndex, "\n");
                insertIndex += 1;
              } else {
                quill.insertText(insertIndex, "\n\n");
                insertIndex += 2;
              }
            }
          }
          quill.setSelection(insertIndex, 0);
        }
      };
      const imageHandler = () => {
        const allowMultiple = true;
        const range = quill.getSelection();
        if (!range) return;

        // Open a file input dialog to insert an image
        // console.log('imageHandler');
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.value = '';
        if (allowMultiple) input.setAttribute('multiple', 'multiple');
        input.addEventListener('change', imageHandlerSelect, { once: true });
        // input.addEventListener('input', imageHandlerSelect, { once: true });
        // input.onchange = () => {
        //   /* 20251111 use bellow code for support multiple
        //   const file = input.files?.[0];
        //   if (file) {
        //     // blob
        //     const blobUrl = URL.createObjectURL(file);
        //     // console.log('blobUrl:', blobUrl);

        //     quill.insertEmbed(range.index, 'image', blobUrl); //imageNode.src);
        //     // Move cursor to the position after the image
        //     quill.setSelection(range.index + 1, 0);
        //     fnProcessImageAfterAdd(blobUrl, file.name);
        //   }
        //     */

        //   // 20251111 change from above to able support multiple
        //   if (input.files) {
        //     let insertIndex = range.index;
        //     for (var ifile = 0; ifile < input.files?.length; ++ifile) {
        //       const file = input.files[ifile];
        //       if (file) {
        //         // blob
        //         const blobUrl = URL.createObjectURL(file);
        //         // console.log('blobUrl:', blobUrl);

        //         quill.insertEmbed(insertIndex, 'image', blobUrl); //imageNode.src);
        //         insertIndex++;

        //         fnProcessImageAfterAdd(blobUrl, file.name);

        //         if (ifile >= input.files?.length - 1) { // last
        //           quill.insertText(insertIndex, "\n");
        //           insertIndex += 1;
        //         } else {
        //           quill.insertText(insertIndex, "\n\n");
        //           insertIndex += 2;
        //         }
        //       }
        //     }
        //     quill.setSelection(insertIndex, 0);
        //   }
        // };
        input.click();
      };

      const fileHandler = () => {
        const quill = quillRef.current?.getEditor();
        if (!quill) return;

        const input = document.createElement("input");
        input.setAttribute("type", "file");


        input.onchange = async () => {
          const file = input.files?.[0];
          if (file) {
            // Convert the file into a Blob URL
            const fileUrl = URL.createObjectURL(file);
            const fileName = "⏹" + file.name;

            const range = quill.getSelection();
            const index = range ? range.index : 0; // Use current selection index or 0 if no selection

            quill.insertText(index, fileName/*"hello"*/);

            //const linkUrl = "https://example.com"; // The link URL you want to assign
            const fileId = Utils.GetUniqueId();
            quill.formatText(index, fileName.length, "link", `https://${fileId}.com/`); // Apply the link format to the word "hello"

            const links = quill.root.querySelectorAll('a');// as HTMLImageElement;
            // console.log('links:', links);
            // console.log('lastImage:', images);
            links.forEach((lnk) => {
              //if (lnk.href == `https://${fileId}.com/` && !lnk.id) {
              //if (!lnk.id) {
              if (!lnk.id && lnk.innerText == fileName) { // 20250815 add check innerText
                lnk.id = Utils.GetUniqueId();
                lnk.href = fileUrl;
                lnk.setAttribute('atype', ATypes.file);
                lnk.className = "a-file";
                // console.log('set a tag type to file');
              }
            });
            // // Insert a link to the file using Quill's link tool
            // const range = quill.getSelection();
            // if (range) {
            //   quill.insertEmbed(range.index, "link", "http://www.goole.com");
            //   // Insert the file name as the link text and set the Blob URL as the href
            //   // quill.insertEmbed(range.index, "link", fileUrl);
            //   // quill.insertText(range.index, `📎${fileName}`, { bold: true });
            // }


            quill.insertText(index + fileName.length, ' ', 'link', false);
            quill.setSelection(index + fileName.length + 1, 0);
          }
        };
        input.click();
      };

      const tagHandler = () => {
        alert('tag');
      }

      const handleSelectionChange = (range: any) => {
        storedRange = range;
        // console.log('storedRange:', storedRange);
        if (range) {
          const quillTooltip = document.querySelector(".ql-tooltip") as HTMLElement;
          if (quillTooltip) {
            // Get the element at the selection
            const [leaf] = quill.getLeaf(range.index);
            if (leaf) {
              let node = leaf.domNode as HTMLElement;

              // Traverse up to find the <a> tag (if exists)
              while (node && node.tagName !== "A" && node.parentElement) {
                node = node.parentElement;
              }

              // If we found an <a> tag with href="#", hide the tooltip
              if (node.tagName === "A" && node.getAttribute("href") === "#") {
                quillTooltip.classList.add("ql-hidden"); // Hide tooltip for `#` links
                return;
              }
            }
          }
          // Cursor position changed
          //console.log('Cursor position changed:', range);
          // Call your handleFocus or similar function here
          // handleCursorChange(range);
        }
      };

      const handleTextChange = (delta: any, oldDelta: any, source: any) => {
        const range = quill.getSelection();
        storedRange = range;
        // console.log('storedRange:', storedRange);
        if (range) {
          const position = range.index; // Get cursor position
          const text = quill.getText(0, position); // Get the text before the cursor
          // console.log(text);

          // Look for '@' symbol
          const lastAtIndex = text.lastIndexOf('@');
          const searchTerm = text.substring(lastAtIndex + 1);
          const foundSpace = searchTerm.indexOf(' ') >= 0;
          const foundBreak = searchTerm.indexOf('\n') >= 0 || searchTerm.indexOf('\r') >= 0 || searchTerm.indexOf('\t') >= 0;
          // 20261021 a space keeps searching (as AND) only while the dropdown is already open;
          // if it's closed, text after the space is normal text
          const showTag = lastAtIndex !== -1 && !foundBreak && (!foundSpace || showMentionDropdownRef.current);
          if (showTag) {
            // console.log('showTag = ' + showTag);
            // console.log('searchTerm:' + searchTerm);
            // console.log('mentioned range:', range);
            setLastTagRange(range);
            updateMentionDropdownPosition(quill, range.index);
            showMentionDropdownAndSearch(searchTerm);
          } else {
            setShowMentionDropdown(false);
          }
          // updateMentionDropdownPosition(quill, range.index);
          // setCursorBound(quill.getBounds(range.index));
        } else {
          // setCursorBound(null);
        }
      }

      {// 20250508 handle clipboard reserve custom tag
        const editor = quill;
        const clipboard = editor.getModule('clipboard') as any;

        // Add matcher for <a> tags
        clipboard.addMatcher('a', (node: any, delta: any) => {
          const href = node.getAttribute('href') || '';
          const tagMetaPrefix = '#chat2s-tag=';

          // A mention tag copied and pasted into a genuinely different browser: Chromium's clipboard
          // sanitizer strips atype/aval/id/class (and even class/id alone) before this ever reaches us,
          // but href reliably survives - App.tsx's copy handler smuggled the stripped attributes through
          // it as an encoded fragment (safe for mentions specifically, since their href is always just
          // the "#" placeholder, never real navigation). Decode it back into the CustomLink format value.
          if (href.startsWith(tagMetaPrefix)) {
            try {
              const meta = JSON.parse(decodeURIComponent(href.slice(tagMetaPrefix.length)));
              delta.ops.forEach((op: any) => {
                if (!op.attributes) op.attributes = {};
                op.attributes.link = { href: '#', class: meta.class, atype: meta.atype, aval: meta.aval, id: meta.id };
              });
              return delta;
            } catch (e) {
              // malformed - fall through and treat it as a normal link below
            }
          }

          const atype = node.getAttribute('atype');

          // If atype exists, assume it's your custom tag and do nothing (let it be ignored here)
          if (atype) {
            return delta;
          }

          // For normal pasted <a>, manually add the href as a 'link' attribute
          if (href) {
            delta.ops.forEach((op: any) => {
              if (!op.attributes) op.attributes = {};
              op.attributes.link = href;
            });
          }

          return delta;
        });

        // Pasting rich content back in (e.g. a copied post) goes through Quill's own clipboard-to-Delta
        // conversion, which derives 'color'/'background' formats from each node's inline/computed style
        // independently of whatever cleanup already happened at copy time. A classless <span> with a
        // background/color style is the browser's own injected wrapper around plain/inherited-color text
        // (not a real app element - those always carry a class, e.g. a-tag/fa*/text-success) - strip just
        // those two formats from it so a theme-specific color never gets baked into the new message;
        // every other format (bold, link, etc.) on the same run is left untouched.
        clipboard.addMatcher('span', (node: any, delta: any) => {
          if (node.classList && node.classList.length > 0) return delta;
          if (!node.style || (!node.style.color && !node.style.backgroundColor && !node.style.background)) return delta;

          delta.ops.forEach((op: any) => {
            if (op.attributes) {
              delete op.attributes.color;
              delete op.attributes.background;
            }
          });
          return delta;
        });
      }

      // Attach custom image handler to Quill
      const toolbar = quill.getModule('toolbar') as any;
      toolbar.addHandler('image', imageHandler);
      toolbar.addHandler('formula', fileHandler);
      // toolbar.addHandler('direction', tagHandler);

      // 20260821 Quill's snow-theme link tooltip (toolbar button #4) centers itself on the
      // selection and can end up partially/fully off-screen when that selection sits near the
      // editor's left edge (or right edge, on a narrow input) - clamp it back within the editor
      // whenever Quill repositions it, instead of patching Quill's own position() method.
      const linkTooltip = document.querySelector('.ql-tooltip') as HTMLElement | null;
      let tooltipObserver: MutationObserver | null = null;
      if (linkTooltip) {
        const clampTooltipPosition = () => {
          if (linkTooltip.classList.contains('ql-hidden')) return;
          const container = linkTooltip.offsetParent as HTMLElement | null;
          if (!container) return;
          const margin = 4;
          const maxLeft = Math.max(margin, container.clientWidth - linkTooltip.offsetWidth - margin);
          const currentLeft = parseFloat(linkTooltip.style.left || '0');
          const clampedLeft = Math.min(Math.max(currentLeft, margin), maxLeft);
          if (Math.abs(clampedLeft - currentLeft) > 0.5) {
            linkTooltip.style.left = `${clampedLeft}px`;
          }
        };
        tooltipObserver = new MutationObserver(clampTooltipPosition);
        tooltipObserver.observe(linkTooltip, { attributes: true, attributeFilter: ['style', 'class'] });
      }

      // quill.root.addEventListener('focus', handleFocus);
      quill.on('selection-change', handleSelectionChange);
      quill.on('text-change', handleTextChange);
      quill.root.addEventListener('paste', handlePaste);
      quill.root.addEventListener('click', handleClick);
      quill.root.addEventListener('keydown', handleKeyDown, true); // 20250814 add true for able to make preventDefault
      return () => {
        // quill.root.removeEventListener('focus', handleFocus);
        quill.off('selection-change', handleSelectionChange);
        quill.off('text-change', handleTextChange);
        quill.root.removeEventListener('paste', handlePaste);
        quill.root.removeEventListener('click', handleClick);
        quill.root.removeEventListener('keydown', handleKeyDown, true);
        tooltipObserver?.disconnect();
      };
    }
  }, [isLargeStage, activePostId]);

  const updateMentionDropdownPosition = (quill: Quill, index: number) => {
    const editorElement = quill.root.closest(".ql-container") as HTMLElement;
    // console.log(editorElement);
    const editorRect = editorElement.getBoundingClientRect();

    const bounds = quill.getBounds(index);
    // console.log({ editorRect, bounds });
    const scrollTop = editorElement.scrollTop;

    if (bounds) {
      const top = 0;//editorRect.top + bounds.top - scrollTop + 30;
      const left = 10;//bounds.left;//editorRect.left + bounds.left;
      // console.log({ left, top });
      setCursorPosition({
        top: top, //editorRect.top + bounds.top - scrollTop + 30, // Adjust for scrolling
        left: left, //editorRect.left + bounds.left,
      });
    }
  };

  const handleMentionSelectByIndex = () => {
    const index = mentionIndexRef.current;
    const list = mentionsRef.current;
    console.log('handleMentionSelectByIndex:', { index, list });
    if (index >= 0 && index < list.length) {
      const mention = list[index];
      // const range = lastTagRangeRef.current;
      // console.log('set mentioned to : ', { mention, lastTagRange, range });
      handleMentionSelect(mention);
      setShowMentionDropdown(false);
    }
  }

  const handleMentionSelect = (mention: sp_WpFindTag) => {
    const rangeToSet = lastTagRange ?? lastTagRangeRef.current;
    if (quillRef.current && rangeToSet/*lastTagRange*/) {
      // const quill = quillRef.current.getEditor();
      // const range = lastTagRange;// quill.getSelection();
      // const lastAtIndex = range.index;// text.lastIndexOf('@');
      // const tagName = `@${mention.name}`;
      // quill.insertText(lastAtIndex, tagName, "link", false);//`@${mention.name}`);
      // quill.formatText(lastAtIndex, tagName.length, "link", "#");
      // quill.setSelection(lastAtIndex + tagName.length, 0);
      const quill = quillRef.current.getEditor();
      const range = rangeToSet/*lastTagRange*/; // Last selection before showing the mention dropdown
      const delta = quill.getContents(0, range.index); // Get Delta (Quill's document model)

      let lastAtIndex = -1;
      let charCount = 0;

      // Loop through the Delta ops to find the last '@'
      delta.ops.forEach(op => {
        if (typeof op.insert === "string") {
          const atIndex = op.insert.lastIndexOf('@');
          if (atIndex !== -1) {
            lastAtIndex = charCount + atIndex;
          }
        }
        charCount += typeof op.insert === "string" ? op.insert.length : 1; // Count images as 1
      });

      if (lastAtIndex !== -1) {
        // close now (not after the effect syncs the ref) so the text-change from inserting "@Name With Space "
        // below isn't treated as a continuing space-AND search
        showMentionDropdownRef.current = false;
        // Remove only the text before the new mention, leaving images untouched
        quill.deleteText(lastAtIndex, range.index - lastAtIndex);

        // Insert the selected mention
        const tagName = `@${mention.name}`;
        quill.insertText(lastAtIndex, tagName, "link", false);
        quill.formatText(lastAtIndex, tagName.length, "link", "#");

        // reformat
        const links = quill.root.querySelectorAll('a');// as HTMLImageElement;
        links.forEach((lnk) => {
          //if (!lnk.id) {
          if (!lnk.id && lnk.innerText?.trim().startsWith("@")) { // 20250626 check only link start with @ for sure its is mentioned tag
            lnk.id = Utils.GetUniqueId();
            lnk.href = "#";
            lnk.className = "a-tag";
            lnk.setAttribute('atype', ATypes.tag);
            lnk.setAttribute('aval', mention.tagId.toString());
          }
        });
        computeTag();

        // Move cursor after the inserted mention
        // quill.setSelection(lastAtIndex + tagName.length, 0);
        // Insert a space at the desired position
        // quill.insertText(lastAtIndex + tagName.length, ' ');
        quill.insertText(lastAtIndex + tagName.length, ' ', 'link', false);
        // Then move the cursor after the inserted space
        quill.setSelection(lastAtIndex + tagName.length + 1, 0);

        setShowMentionDropdown(false);
      }
    }
  }


  const modules = {
    toolbar: [
      // [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }], ไม่ใส่ก่อน
      ['bold', /*'italic',*/ 'underline', /*'strike',*/ 'direction', /*{ 'color': myColors }, { 'background': myColors }*/, // 20250505 เอาสีออกก่อน, 20250508 เอา direction เป็น emoji
        'link', 'image', 'formula', /*'direction', 'video'*/, // formula แทน file, direction = tag,  video ยังไม่ work
        // ['blockquote', 'code-block'], // เอาออกก่อน มันยาว
        //[{ 'list': 'ordered' }, { 'list': 'bullet' }/*, { 'list': 'check' }*/], //-> ไม่แสดงก่อน ใน mobile ทำให้เป็น 2 line แล้ว layout มันไม่ตรง
        //[{ 'script': 'sub'}, { 'script': 'super' }], เอาออกก่อน มันยาว
        //[{ 'indent': '-1'}, { 'indent': '+1' }], // เอาออกก่อน มันยาว
        'clean',
        // 'strike',
        'customtag'
      ], /* 20250510 for tag */
      // ['formula'],


      //['formula'
      //{ 'direction': 'rtl' }, 
      // { 'size': ['small', false, 'large', 'huge'] }, 
      // { 'header': [1, 2, 3, 4, 5, 6, false] }, 
      // { 'font': [] }, { 'align': [] }
      //]

      //["bold", "italic", "underline", "strike"/*, "blockquote"*/, { color: myColors }, "clean"],
      // [{ align: ["right", "center", "justify"] }],
      // [{ list: "ordered" }, { list: "bullet" }],
      //["link", "image", "attachFile"],
      // [{ color: myColors }],
      // [{ background: myColors }]
    ],
    keyboard: { // 20250425 disable auto bullet
      bindings: {
        'list autofill': {
          prefix: /^\s*()$/
        }
      }
    }

    //toolbar: "#toolbar"

    // imageResize: { // comment first because get exception when delete selected (active) image
    //   parchment: Quill.import('parchment'),
    //   modules: ['Resize', 'DisplaySize'],
    // }
  };

  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (quillRef.current) {
      const quillInstance = quillRef.current.getEditor(); // Get Quill instance
      const editorElement = quillInstance.root as HTMLElement; // Get the `.ql-editor` element
      const gap = viewport.width < Const.BREAKPOINT_MD ? 15 : 5;

      if (editorElement) {
        // console.log('set height to = ' + (editorMinHeight - gap));
        editorElement.style.minHeight = `${editorMinHeight - gap}px`;
        editorElement.style.maxHeight = `${editorMaxHeight - gap}px`;
      }
    }
    // console.log({ editorMinHeight, editorMaxHeight });
  }, [viewport, editorMinHeight, editorMaxHeight]); // Re-run if values change  

  useEffect(() => {
    if (showMentionDropdown && quillRef.current) {
      const editor = quillRef.current.getEditor();
      const range = editor?.getSelection();
      const bounds = range ? editor.getBounds(range.index) : null;
      setCursorBound(bounds);
    }
  }, [showMentionDropdown]);

  const [isOnSaveIn, setIsOnSaveIn] = useState<boolean>(false);
  const onSaveIn = () => {
    if (sendLockedRef.current) return; // member check still running
    if (!isOnSaveIn) {
      setWpTagToolboxOpen(false);
      setIsOnSaveIn(true);
      onSaveIn2();
      setIsOnSaveIn(false);
    }
  }

  const onSaveIn2 = () => {
    try {
      if (quillRef.current) {
        const editor = quillRef.current.getEditor();
        const atypeElements = editor.root.querySelectorAll('[atype]');
        const blobUploads: QuillFileUpload[] = [];
        const tagData: QuillTagData[] = [];
        const text = editor.getText().trim();
        let html = editor.root.innerHTML.trim();

        // Regex to match the last <p><br></p> at the end of the string
        const regex = /<p><br><\/p>\s*$/;
        // Replace the matched part with an empty string
        html = html.replace(regex, '');
        // console.log('html=' + html);

        const fileNameCount = new Map<string, number>();
        atypeElements.forEach((tag) => {
          const atype = tag.getAttribute('atype');
          if (atype == ATypes.file || atype == ATypes.image) {
            let fileName = "";
            if (atype == ATypes.file) {
              fileName = Utils.ConvertHtmlToText(tag.innerHTML) ?? "";
            } else {
              fileName = tag.getAttribute("fname") ?? ""; // not have file name because paste from clipboard
              if (fileName == "") fileName = "clipboard.png";
            }

            // ✅ Deduplication logic
            const baseName = fileName.replace(/\(\d+\)(?=\.[^.]+$)/, ""); // Remove any existing (n)
            const extensionIndex = baseName.lastIndexOf(".");
            const namePart = extensionIndex !== -1 ? baseName.substring(0, extensionIndex) : baseName;
            const extPart = extensionIndex !== -1 ? baseName.substring(extensionIndex) : "";

            const count = fileNameCount.get(baseName) || 0;
            fileNameCount.set(baseName, count + 1);

            const finalFileName = count === 0 ? baseName : `${namePart}(${count})${extPart}`;

            blobUploads.push({
              id: tag.id,
              atype: atype,
              blobUrl: (atype == ATypes.file ? tag.getAttribute('href') : tag.getAttribute('src')) ?? "",
              fileName: finalFileName,
            });
          } else if (atype == ATypes.tag) {
            tagData.push({
              id: tag.id,
              tagId: Utils.ToNumber(tag.getAttribute('aval'), -1) ?? -1,
              tagName: Utils.ConvertHtmlToText(tag.innerHTML),
            });
          }
        });

        const proceedSave = () => {
          if (wpMode == WpModes.Workplace) {
            if (text == "" && blobUploads.length <= 0) {
              alert('No content');
              return;
            }
          } else if (wpMode == WpModes.Task && (!activePostId || isCreateSubTaskMode)) { // New task
            if (!taskData.taskName) {
              alert('กรุณาระบุชื่องาน');
              return;
            }
            if (!taskData.respondId) {
              alert('กรุณาระบุ เจ้าของงาน');
              return;
            }
          }

          // console.log('blobUploads:', blobUploads);
          // Used to call editor.enable(false)/(true) around the save to block editing while
          // it's in flight, but enable(false) sets contenteditable=false on the root, which
          // forces the browser/WebView to blur it - the on-screen keyboard hides, then pops
          // back up when re-enabled, producing a visible flicker (worse on native where the
          // keyboard show/hide also re-triggers the WindowInsets resize in MainActivity.java).
          // Re-entrancy is already guarded by the Send button's onSaving-driven disabled state
          // below, so the editor no longer needs to be disabled here - it just stays focused
          // and the keyboard never moves.
          onSave(text, html, blobUploads, tagData)
            .then((rs) => {
              //if (rs) {
              if (rs == "") { // 20250722 save success
                setTimeout(() => {
                  editor.setContents([{ insert: "" }]);
                  setCode("");
                }, 50);
                setTimeout(() => { // 20250722 try to make sure that text not persist on editor
                  editor.setContents([{ insert: "" }]);
                  setCode("");
                }, 100);
                setTimeout(() => { // 20250722 try to make sure that text not persist on editor
                  editor.setContents([{ insert: "" }]);
                  setCode("");
                }, 200);
              } else {
                console.error('Cannot save post:', rs);
                // alert('Cannot save post');
                alert(rs);
              }
            }).catch((e) => {
              Utils.HandleException(e, true);
            });
        };

        // 20260821 catch links whose atype/href ended up inconsistent with their visible text -
        // most commonly a plain hyperlink that silently inherited atype/class="a-tag"/"a-file" from
        // an old @tag/file link it replaced (see CustomLink.format above). Warn and let the user
        // decide rather than hard-blocking, since a false positive here shouldn't trap a real post.
        const linkIssues = findSuspiciousLinks(editor.root);
        if (linkIssues.length > 0) {
          Utils.SweetConfirm(
            `พบลิงก์ที่ข้อมูลอาจไม่ถูกต้อง กรุณาตรวจสอบก่อนโพสต์:<br/><ul style="text-align:left">${linkIssues.map((i) => `<li>${i}</li>`).join('')}</ul>ยืนยันจะโพสต์ต่อหรือไม่?`
          ).then((result) => {
            if (result.isConfirmed) proceedSave();
          });
        } else {
          proceedSave();
        }

        //const editor = quillRef.current?.getEditor(); // Get Quill instance
        // if (editor) {
        //   // Set initial content with bold and underlined text
        //   editor.setContents([
        //     { insert: "" },
        //     // { insert: "XXX", attributes: { bold: true, underline: true } },
        //   ]);
        // }

        // console.log({ text, html });
      } else {
        alert('quillRef not valid');
      }

    } catch (e) {
      Utils.HandleException(e);
    }
  }

  const [saveFileErrorMsg, setSaveFileErrorMsg] = useState<string[]>([]);

  const onSave = async (text: string, html: string, blobUploads: QuillFileUpload[], tags: QuillTagData[]): Promise<string/*boolean*/> => {
    let saveResult = false;
    let errMsg = "";
    try {
      // console.log({ text, html, blobUploads, tags });
      setOnSaving(true);
      // const postId = activePostId ? activePostId : Utils.GetUniqueId();
      const isNewMainPost = !activePostId || isCreateSubTaskMode;
      const postId = Utils.GetUniqueId();
      const postIdTop = isNewMainPost/*!activePostId*/ ? postId : activePostId;
      const postIdParent = isNewMainPost/*!activePostId*/ ? postId : activePostId;
      const deep = !isNewMainPost/*activePostId*/ ? 1 : 0;

      const api = new APIClient

      // Upload each Blob URL asynchronously
      setSaveFileErrorMsg([]);
      const uploadPromises = blobUploads.map((blob: QuillFileUpload, idx: number) => {
        const system = wpMode == WpModes.Workplace ? Const.SYS_WORKPLACE : Const.SYS_TASK;
        //return api.uploadFile(blob.blobUrl, idx + 1, blob.fileName, postId, Const.SYS_WORKPLACE, blob.id, false)
        return api.uploadFile(blob.blobUrl, idx + 1, blob.fileName, postId, system, blob.id, false, blob.atype.toString())
          .then((resp: any) => {
            if (resp.error) {
              const msg = saveFileErrorMsg;
              msg.push(resp.error);
              setSaveFileErrorMsg(msg);
              return false;
            } else {
              html = html.replace(blob.blobUrl, blob.atype == ATypes.image ? resp.urlThumb : resp.url);
              // if (blob.atype == ATypes.image){
              //   html = html.replace(`atype=`, `onclick="onQuillLinkClick(this); return false;" atype=`);
              // }
              return true;
            }
          });
      });
      // tags.forEach((e:QuillTagData)=>{
      //   html = html.replace(`atype=`, `onclick="onQuillLinkClick(this); return false;" atype=`);
      // });

      // Wait for all uploads to complete
      const results = await Promise.all(uploadPromises);
      //console.log(results);
      const successCount = results.filter(result => result).length;
      //console.log('upload file done:', successCount, successCount);
      if (successCount == blobUploads.length) {
        const tagString: string[] = [];
        tags.forEach((e) => { tagString.push(e.tagId + Const.DELIM_VALUE + e.tagName) });
        const arg = {
          postId: postId,
          postIdTop: postIdTop,
          postIdParent: postIdParent,
          deep: deep,
          isEdit: false,
          text: text,
          html: html,
          tags: tagString,
          deviceId: Utils.GetDeviceId()
        };
        let apiUrl = url.WP_SAVE_POST;
        if (wpMode == WpModes.Task) {
          apiUrl = url.WP_SAVE_POST_TASK;
          if (deep == 0) {/*only new post*/
            (arg as any).taskName = taskData?.taskName;
            (arg as any).docType = taskData?.docType;
            (arg as any).priority = taskData?.priority;
            (arg as any).projectId = taskData?.projectId;
            (arg as any).assignerId = taskData?.assignerId;
            (arg as any).respondId = taskData?.respondId;
            (arg as any).requestBy = taskData?.requestBy;
            (arg as any).planFinishedDate = taskData?.planFinishedDate;
            (arg as any).createSubTaskFromTaskId = createSubTaskFromTaskId;
          }
        }
        // console.log(`arg :`, { apiUrl, wpMode, deep, arg });
        const rs = await api.fnPostForm(apiUrl, arg);
        // console.log('rs:', rs);
        // message.attachments = null;
        // message.image = "image";
        // sendErr = await connection.invoke("SendMessage", message);
        if (rs.success) {
          saveResult = true;
          errMsg = "";
          // console.log('rs.data:', rs.data);
          if (!isNewMainPost /*activePostId*/) { // if reply to existing post, then append message
            dispatch(appendPostConver(rs.data));
            // console.log('tagString:', tagString);
            if (tagString.length > 0) { // have tag in this post, then query tag again
              dispatch(loadPostInfo(wpMode, postIdParent));
            }
          } else { // if create new post then change view
            let curRole = activeMemberRole;
            if (curRole !== MemberRole.MyPost && curRole !== MemberRole.All) {
              curRole = MemberRole.All;
              dispatch(setActiveMemberrole(wpMode, curRole));
            }

            dispatch(setActivePostId2(wpMode, postId, "reload", null, null, null, "Quill on save"));
            // dispatch(loadPostTitle("", [], curRole/*MemberRole.MyPost*/, null, false, false, WpEmpFilterType.Poster)); 20250623 take out because its have signalR to add new topic to title list
            // dispatch(loadPostInfo(postId));
          }
          if (isLargeStage) {
            onLargeStageClick();
          }
          Utils.WpDraft_Del(wpMode, isNewMainPost ? "" : activePostId /*?? ""*/, dispatch); // 20250815 this code make title changed because draft in title is change, move here to preview useEffect[title] in other componen
          await Utils.WpDraft_SaveTk(null);
          setTaskData(emptyTaskData);
        } else {
          errMsg = rs.message;
          alert(rs.message);
        }

      } else {
        errMsg = saveFileErrorMsg.join("\n");
        alert('ไม่สามารถบันทึกรูปภาพ หรือไฟล์แนบได้ ' + saveFileErrorMsg.join("<br/>") + ' กรุณาติดต่อผู้ดูแล');
      }

      setOnSaving(false);
    } catch (e) {
      Utils.HandleException(e);
      errMsg = Utils.GetMessageFromExecption(e);
      setOnSaving(false);
    }
    return saveResult ? "" : errMsg;
    // return saveResult;
  }

  useEffect(() => {
    // console.log('showMentionDropdown = ' + showMentionDropdown);
  }, [showMentionDropdown]);

  useEffect(() => {
    // console.log('isFindTag = ' + isFindTag);
  }, [isFindTag]);

  const onCancelPost = () => {
    if (isEmbChatOnly) {
      if (quillRef.current) {
        const editor = quillRef.current.getEditor();
        setTimeout(() => {
          editor.setContents([{ insert: "" }]);
          setCode("");
        }, 100);
      }
    } else {
      if (createSubTaskFromTaskId) {
        dispatch(setCreateSubTask(null));
      } else {
        dispatch(setActivePostId2(wpMode, null, null, null, null, null, "Quill cancel post"));
        dispatch(changeSelectedChat(null));
        Utils.WpDraft_Del(wpMode, activePostId ?? "", dispatch);
      }
    }
  }

  const onEditorInfoClick = () => {
    alert([
      `- คัดลอกและวาง tag หรือ inline file แนบ, รูปภาพ ภายใน editor ยังไม่สมบูรณ์`,
    ].join("<br/>"));
  }

  const [selectedTag, setSelectedTag] = useState<QuillTagData[]>([]);

  const computeTag = async () => {
    try {
      if (quillRef.current) {
        const editor = quillRef.current.getEditor();
        const atypeElements = editor.root.querySelectorAll('[atype]');
        const tagData: QuillTagData[] = [];
        atypeElements.forEach((tag) => {
          const atype = tag.getAttribute('atype');
          if (atype == ATypes.tag) {
            const tagId = Utils.ToNumber(tag.getAttribute('aval'), -1);
            if (tagData.findIndex(t => t.tagId === tagId) < 0) {
              tagData.push({
                id: tag.id,
                tagId: Utils.ToNumber(tag.getAttribute('aval'), -1) ?? -1,
                tagName: Utils.ConvertHtmlToText(tag.innerHTML),
              });
            }
          }
        });
        setSelectedTag(tagData);
        // console.log('sel tag:', tagData);
      }

    } catch (e) {
      Utils.HandleException(e, false);
    }
  }

  const onClickTag = (tagId: number, tagName: string, isAdd: boolean) => {
    const quill = quillRef?.current?.getEditor()
    if (quill) {
      if (isAdd) {
        // console.log('set tag ' + tagId + ':' + tagName);
        let index = quill.getLength(); // insert at end of editor first, if need at cursor positionthen have to define storeRange to const storedRangeRef = useRef<any>(null);
        const isEmpty = quill.getText().trim().length === 0;
        if (isEmpty) index = 0;
        if (index > 1) index--;
        // console.log('index = ' + index);
        const tagName2 = `@${tagName}`;

        // Insert the text
        quill.insertText(index, tagName2, "link", "#");

        // reformat
        const links = quill.root.querySelectorAll('a');// as HTMLImageElement;
        links.forEach((lnk) => {
          if (!lnk.id) {
            lnk.id = Utils.GetUniqueId();
            lnk.href = "#";
            lnk.className = "a-tag";
            lnk.setAttribute('atype', ATypes.tag);
            lnk.setAttribute('aval', tagId.toString());
          }
        });

        // Move cursor index forward by tag length
        index += tagName2.length;

        quill.insertText(index, ' ', 'link', false);
      } else { // remove tag
        const atypeElements = quill.root.querySelectorAll('a[atype="tag"]');
        atypeElements.forEach((el) => {
          if (el.getAttribute('aval') == tagId.toString()) {
            el.remove(); // Completely remove the <a> and all its content
          }
        });
      }
      // index += 1;
      // Set cursor after the inserted space
      // quill.setSelection(index);
      computeTag();
    }
  }

  const [wpTagToolboxOpen, setWpTagToolboxOpen] = useState<boolean>(false);
  // useEffect(() => { console.log('wpTagToolboxOpen = ' + wpTagToolboxOpen); }, [wpTagToolboxOpen]);


  const onSetEmojiToolBar = (emoji: any) => {
    try {
      const quill = quillRef?.current?.getEditor()
      const range = quill?.getSelection(true);
      if (quill && range) {
        quill.insertText(range.index, emoji.icon);
        quill.setSelection(range.index + emoji.icon.length);
      }
      setShowEmojiToolPlate(false);
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const emojiToolRef = useRef<HTMLDivElement | null>(null);

  // hide emoji toolbar when focus outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (
        emojiToolRef.current &&
        !emojiToolRef.current.contains(event.target as Node)
      ) {
        setShowEmojiToolPlate(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [setShowEmojiToolPlate]);


  const allowExpand =
    (wpMode == WpModes.Task && (!activePostId || createSubTaskFromTaskId)) /*ย่อแล้วเพี้ยน เพราะมีช่องให้กรอกด้านบน ไม่ให้ย่อไปก่อนขั้นต้น*/
      ? false
      : true;
  // console.log('WorkplaceQuill:', { wpMode, activePostId });
  // console.log('mentions:', mentions);
  const mentionDivRef = useRef<HTMLDivElement>(null);
  const mentionActiveItemRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (mentionActiveItemRef.current) {
      mentionActiveItemRef.current.scrollIntoView({
        block: 'nearest', // important: avoids jumping
        behavior: 'smooth' // optional
      });
    }
  }, [mentionIndex]);
  return (
    <>
      {(wpMode == WpModes.Task && (activePostId == "" || createSubTaskFromTaskId)) && (
        <div className="mb-1">
          <TaskFormField formData={taskData} onFormChanged={onTaskFormChanged} />
          รายละเอียด
        </div>
      )}
      <ReactQuill
        theme="snow"
        ref={quillRef}
        modules={modules}
        formats={formats}
        value={code}
        onChange={handleProcedureContentChange}
      />
      {showMentionDropdown && (
        <AppSimpleBar className="workplae-mention-dropdown"
          style={{
            // top: cursorPosition.top - 110/*150*/,
            // left: cursorPosition.left
            //top: 0 - 130 + (cursorBound?.top ?? 0) + (wpMode == WpModes.Task && !activePostId ? 260 : 0),
            bottom: (isLargeStage ? 580 : 150) - (wpMode == WpModes.Task && !activePostId ? 260 : 0), /*20260122 adjust because dock input at bottom (position style changed)*/
            left: 10, //Math.min(10 + (cursorBound?.left ?? 0), 100),
          }}>
          {isFindTag && (<Loader></Loader>)}
          <div ref={mentionDivRef}>
            {mentions.map((mention: sp_WpFindTag, idx: number) => {
              const tagCat = tagMasterCats.find(x => x.category == mention.category);
              const faIcon = tagCat?.faIcon ?? "fas fa-tag";
              const faColor = tagCat?.faColor ?? "#201d04";
              const faBg = tagCat?.bgColor ?? "#b2b3ad";
              let comp = '';
              let name = mention.name;
              if (mention.category == Const.WP_CAT_EXU) {
                const xx = mention.name.split('|');
                comp = xx[0];
                name = xx[1];
                if (!comp) comp = "external";
              }
              // console.log('mention ' + mention.category + ':', {faIcon, faColor, faBg});
              return (
                <div key={mention.tagId} ref={idx === mentionIndex ? mentionActiveItemRef : null} onClick={() => handleMentionSelect(mention)} className={"workplae-mention-dropdown-item" + (idx == mentionIndex ? " active-primary" : "")}>
                  <i className={faIcon} style={{ textAlign: "center", width: "18px", color: faColor, backgroundColor: faBg }}></i>&nbsp;
                  {mention.category == Const.WP_CAT_EXU && (<span className="badge badge-soft-primary rounded p-1 ml-1 bg-danger">({comp})</span>)}
                  {name}
                </div>
              )
            })}
          </div>
        </AppSimpleBar>
      )}

      {showEmojiToolPlate && (
        <div ref={emojiToolRef} className="workplae-emoji-tool row"
          style={{
            //top: -140, //cursorPosition.top - 110/*150*/,
            bottom: isLargeStage ? 580 : 150, /*20260122 adjust because dock input at bottom (position style changed)*/
            left: 20, //cursorPosition.left
            // top: 0,
            // left: 10, //Math.min(10 + (cursorBound?.left ?? 0), 100),
          }}>

          {emojis.map((emoji, index) => (
            <React.Fragment key={index}>
              <div
                // key={index}
                className="col text-center workplae-emoji-tool-each hover"
                onClick={() => onSetEmojiToolBar(emoji)}
                style={{ cursor: 'pointer', fontSize: '1.5rem'/*, margin: '5px 0', width: "30px", height: "30px"*/ }}
                title={emoji.name}
              >
                {emoji.icon}
              </div>
              {(index + 1) % 4 == 0 && (<div className="w-100"></div>)}
            </React.Fragment>
          ))}
        </div>
      )}

      <div className="" style={{ display: "flex", justifyContent: "space-between", marginTop: "3px", paddingBottom: "5px" }}>
        <div >
          {allowExpand && (
            <button className="btn btn-link btn-sm" onClick={onLargeStageClick} >
              <i className={isLargeStage ? "fas fa-angle-double-down fz-13" : "fas fa-angle-double-up fz-13"}></i>
            </button>
          )}
          {/* <button className="btn btn-link btn-sm"> 20250510 ย้ายปุ่ม tag ไปไว้ที่ toolbar
            <i className="fas fa-at fz-13" onClick={() => setWpTagToolboxOpen(prev => !prev)}></i>
          </button> */}

          {/* &nbsp;
          <span className="text-red hand" onClick={onEditorInfoClick}>❗️ข้อจำกัด editor</span> */}
        </div>
        <div >
          {/* onMouseDown+preventDefault on both buttons: tapping a plain <button> steals
              focus from the Quill editor by default (the browser's normal focus-on-click
              behavior), which blurs the contenteditable and dismisses the keyboard - it then
              pops back up once the editor gets refocused after send, which reads as a
              flicker. Same technique Quill's own toolbar buttons use internally to avoid
              dismissing the keyboard when tapped. */}
          {!instantMode && (<><button className="btn btn-warning btn-sm" onMouseDown={(e) => e.preventDefault()} onClick={onCancelPost}><i className="fas fa-chevron-left p-1"></i>Back</button>&nbsp;</>)}
          < button className={classnames("btn btn-primary btn-sm", { "disabled": onSaving || sendLocked })} onMouseDown={(e) => e.preventDefault()} onClick={onSaveIn} style={{ minWidth: "60px" }} title={sendLocked ? "กำลังตรวจสอบสิทธิ์" : undefined}>
            {(onSaving || sendLocked) && (<><LoadingIconWithText loadingText={""}></LoadingIconWithText>&nbsp;</>)}
            {(activePostId && !createSubTaskFromTaskId) ? (<>Reply</>) : (<>{wpMode == WpModes.Workplace ? "Post" : (createSubTaskFromTaskId ? "Create Sub Task" : "Create Task")}</>)}

          </button>
        </div>
      </div >

      <FloatingToolbox name="WpTagToolbox" title="Set Tag WorkPlace" isOpen={wpTagToolboxOpen} toggle={() => setWpTagToolboxOpen(prev => !prev)} >
        <WpTagToolbox isOpen={wpTagToolboxOpen} onClickTag={onClickTag} selectedTags={selectedTag} wpMode={wpMode} />
      </FloatingToolbox>
    </>
  );
}

